<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<router-outlet >
    <ngx-spinner bdColor="rgba(51,51,51,0.7)" size="large" color="#fff" type="ball-clip-rotate"></ngx-spinner>

    <!-- <ngx-spinner >
        template="<img src='/assets/loader.gif' />" 
        </ngx-spinner> -->
</router-outlet>